import React from "react";
import CreatEditCompanyContainer from "../../../containers/ListCompany/CreateEditCompany";

const CreateEditCompanyScreen = () => {
  return <CreatEditCompanyContainer />;
};

export default CreateEditCompanyScreen;
